module.exports = __webpack_public_path__ + "img/portrait.d0fe7c9b.jpg";